import IntegrationCallStateOverviewListResultModelBase from '../_generated/modelBases/integration-call-state-overview-list-result-model-base';

export default class IntegrationCallStateOverviewListResultModel extends IntegrationCallStateOverviewListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
